import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
export default function AdminLayout(){
  const loc = useLocation();
  const Tab = ({to,label}:{to:string;label:string})=>(
    <Link to={to} className={`px-3 py-2 rounded ${loc.pathname.startsWith(to)?'bg-gray-200':'hover:bg-gray-100'}`}>{label}</Link>
  );
  return (<div className="flex h-screen">
    <aside className="w-60 border-r p-3 space-y-2">
      <div className="font-bold text-sm uppercase tracking-wide text-gray-600">Admin</div>
      <nav className="flex flex-col gap-1">
        <Tab to="/admin/overview" label="Overview" />
        <Tab to="/admin/composer" label="Composer" />
        <Tab to="/admin/templates" label="Templates" />
        <Tab to="/admin/runs" label="Runs" />
      </nav>
    </aside>
    <main className="flex-1 overflow-auto p-4"><Outlet/></main>
  </div>);
}
